<template>
  <div>
    <van-nav-bar :title="$t('app.login.login')" />
    <div class="wrap">
      <div class="logo">
        <img
          :src="$store.state.login_logo_url"
          style="width: 100%"
          v-if="$store.state.login_logo_url"
        />
        <img
          :src="require('../assets/images/' + $store.state.login_logo_img)"
          style="width: 100%"
          v-if="!$store.state.login_logo_url"
        />
      </div>
      <van-form @submit="onLogin">
        <van-field
          v-model="phone"
          type="tel"
          name="phone"
          :label="$t('app.login.phone_number')"
          :placeholder="$t('app.login.phone_number_placeholder')"
          autocomplete="off"
        />
        <van-field
          v-model="password"
          type="password"
          name="password"
          :label="$t('app.login.password')"
          :placeholder="$t('app.login.password_placeholder')"
          autocomplete="off"
        />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="danger"
            size="small"
            native-type="submit"
          >
            {{$t("app.login.login")}}
          </van-button>
        </div>
      </van-form>
      <van-row>
        <van-col span="12">
          <router-link to="/registered">
            <p class="register">{{$t("app.login.register")}}</p>
          </router-link>
        </van-col>
        <van-col span="12">
          <router-link to="/forget">
            <p class="forget">{{$t("app.login.forgetpass")}}</p>
          </router-link>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import { version,description } from "../../package";
export default {
  name: "Login",
  data() {
    return {
      phone: "",
      password: "",
      isFromChat: "",
    };
  },
  methods: {
    // add public key encryption code when no key in local storage
    getEncyptedPublicKey() {
      let encriptedPublicKey = localStorage.getItem("encript_public_key");

      if (!encriptedPublicKey) {
        let that = this;
        const toast = that.$ShowCommonLoading();
        that
          .$http({
            url: "/",
            method: "POST",
            data: {
              nozzle: "home",
            },
          })
          .then((ret) => {
            let resData = ret.data;
            if (resData.code === 1) {
              toast.clear();
              localStorage.setItem(
                "encript_public_key",
                resData.data.encript_public_key
              );
            } else {
              toast.clear();
              that.$toast.fail(that.$t(resData.msg));
            }
          })
          .catch(() => {
            toast.clear();
            that.$toast.fail(that.$NoNetworkErrorMsg);
          });
      }
    },
    onLogin(values) {
      let that = this;
      const toast = that.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: that.$t("app.common.loading"),
      });
      let publicKey = localStorage.getItem("encript_public_key");
      let userPhone = that.phone.toString();
      let phoneNumber = that.encryptMessage(userPhone, publicKey);
      let userPasword = that.encryptMessage(that.password, publicKey);
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "login_e",
            phone: phoneNumber,
            password: userPasword,
            app_version: version,
            build_number: description,
            build_type:process.env.buildType
          },
        })
        .then(function (res) {
          let resData = res.data;
          localStorage.setItem("password", that.password);
          if (resData.code === 1) {
            toast.clear();
            window.sessionStorage.setItem("loginType", true);
            window.sessionStorage.setItem("token", resData.data.token);
            that.$store.commit("changeLoginType", true);
            that.$store.commit("changePhone", that.phone);
            if(process.env.AUTO_LOGIN) {
              window.localStorage.setItem("al",btoa(JSON.stringify({u:userPhone,p:that.password})));
            }
            let user_number = resData.data.user_number;
            localStorage.setItem("user_number", user_number);
            that.isFromChat
              ? that.$router.push({
                  path: "service_chat",
                  query: { account: user_number },
                })
              : that.$router.push("/member");
            //call login service in chat
            that.loginService();
          } else if (resData.code === 0) {
            toast.clear();
            that.$toast.fail(that.$t(resData.msg));
          }
        })
        .catch(() => {
          toast.clear();
        });
    },
    loginService() {
      let accountNumber = localStorage.getItem("user_number");
      let password = localStorage.getItem("password");
      // console.log("account", accountNumber);
      this.$http({
        url: this.$chatApiURL + "/api/user/login",
        method: "post",
        data: {
          account: accountNumber,
          password: md5(password),
        },
      }).then(function (res) {
        if (res.data.code == 200) {
          window.localStorage.chatToken = res.data.token;
        }
      });
      // $.post("http://47.242.244.129:9080/api/user/login", {account:accountNumber,password:md5(password)},
      //   function(data){
      //     console.log("dataegrger",data);
      //     if(data.code==200){
      //       // window.localStorage.token = data.token;
      //       // window.localStorage.account = account;
      //       // CIMPushManager.connect();
      //     }
      // });
    },
    isLogin() {
      let that = this;
      if (that.$store.state.loginType) {
        this.$router.push("/member");
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
  },
  mounted: function () {
    this.$route.query.chat
      ? (this.isFromChat = true)
      : (this.isFromChat = false);
    this.isLogin();
    this.getEncyptedPublicKey();
  },
};
</script>

<style scoped>
.wrap {
  width: 90%;
  margin: 0 auto;
}
.logo {
  width: 50%;
  margin: 100px auto 0;
}
.register {
  margin: 0;
  font-size: 14px;
  color: #e30614;
}
.forget {
  margin: 0;
  font-size: 14px;
  text-align: right;
  color: #e30614;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue